import { render } from "./App.vue?vue&type=template&id=304f5082"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=304f5082&lang=css"

import exportComponent from "D:\\Code Backup\\ts-web-old\\TatSingGroup-Web\\ts-trading\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__